import styled from '@emotion/styled';
import { mediaMin, breakpoints } from 'styles';

export const BreadcrumbWrapper = styled.nav`
  margin-top: 14px;

  ${mediaMin(breakpoints.tabletXS)} {
    margin-top: 26px;
  }
`;

export const BreadcrumbList = styled.ol`
  display: flex;
  column-gap: 12px;
  align-items: center;
  padding: 0;
  margin: 0;
  overflow-x: auto;
  padding-bottom: 4px;

  ${mediaMin(breakpoints.tabletXS)} {
    padding-bottom: 0;
  }
`;

export const BreadcrumbItem = styled.li`
  position: relative;
  font-size: 14px;
  white-space: nowrap;
  text-overflow: ellipsis;

  &:not(:last-child) {
    display: flex;
    align-items: center;
    gap: 12px;

    &::after {
      content: '';
      display: flex;
      width: 6px;
      height: 10px;
      background-repeat: no-repeat;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='10' viewBox='0 0 6 10'%3E%3Cg transform='translate(-745.869 -1027.414)'%3E%3Cpath d='M.364,9.618a1.354,1.354,0,0,1,0-1.847L3,5,.364,2.229a1.353,1.353,0,0,1,0-1.847,1.2,1.2,0,0,1,1.757,0L5.636,4.077a1.354,1.354,0,0,1,0,1.847L2.121,9.618a1.2,1.2,0,0,1-1.757,0Z' transform='translate(745.869 1027.414)' fill='%23dcdfe3'/%3E%3C/g%3E%3C/svg%3E");
    }
  }

  &:last-child {
    font-weight: 500;
    color: var(--qr-global-color-blue);
  }

  a {
    text-decoration: none;
    color: var(--qr-global-color-text-primary);
    transition: 0.5s ease all;

    &:hover {
      color: var(--qr-global-color-blue);
      transition: 0.5s ease all;
    }
  }
`;
